import React from 'react';
import { T } from '../constants';

export default function RegimePanel({ regime }) {
  if (!regime?.loaded) return null;
  const wr  = regime.rolling_wr_20;
  const cb  = regime.circuit_breaker;
  const rw  = regime.regime_warning;
  const pct = wr ? `${(wr * 100).toFixed(1)}%` : '—';

  return (
    <div className="mini-panel">
      <div className="mini-panel-title">Regime</div>
      <div className="mini-panel-body">
        <div className="mini-row">
          <span style={{ color: T.textMuted }}>Win Rate (20)</span>
          <span className="mono" style={{ fontWeight: 700, fontSize: 12, color: wr && wr < 0.75 ? T.bear : T.bull }}>{pct}</span>
        </div>
        <div className="mini-row">
          <span style={{ color: T.textMuted }}>Circuit Breaker</span>
          <span style={{ fontSize: 10, fontWeight: 700, color: cb ? T.bear : T.bull }}>{cb ? 'ACTIVE' : 'OK'}</span>
        </div>
        <div className="mini-row">
          <span style={{ color: T.textMuted }}>Warning</span>
          <span style={{ fontSize: 10, fontWeight: 700, color: rw ? '#f0b90b' : T.bull }}>{rw ? 'WARN' : 'OK'}</span>
        </div>
      </div>
    </div>
  );
}
